export default __webpack_public_path__ + "static/media/do.5fb13b80.svg";